import React, { useEffect, useState } from 'react';
import '../css/LoginPage.css';
import Footer from './Footer';
import ProfileNavBar from './ProfileNavBar';
import UserFooter from './UserFooter';
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { BarChart, ResponsiveContainer } from 'recharts';
import { FaTrophy } from 'react-icons/fa';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { PieChart, Pie, Cell } from 'recharts';
import '../css/ProgressDashboard.css';
import ChatComponent from './ChatComponent';


const ProgressDashboard = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user) {
        window.location.href = '/';
    }
    const COLORS = ['#8884d8', '#e0e0e0'];
    const [data, setData] = useState([]);
    const [topActivities, setTopActivities] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [showWorkout, setShowWorkout] = useState(true);
    const [showSwimming, setShowSwimming] = useState(false);
    const [showCycling, setShowCycling] = useState(false);
    const [showRunning, setShowRunning] = useState(false);
    const [showYoga, setShowYoga] = useState(false);
    const [showMeditation, setShowMeditation] = useState(false);
    const [showWalking, setShowWalking] = useState(false);
    const [grouping, setGrouping] = useState('day');
    const [groupedChartData, setGroupedChartData] = useState([]);
    const [comparisonData, setComparisonData] = useState([]);
    const [individualProgress, setIndividualProgress] = useState({});
    const [frequency, setFrequency] = useState('daily'); // 'daily', 'weekly', 'monthly'
    const [usersPlan, setUsersPlan] = useState(null);



    useEffect(() => {
        const fetchLogs = async () => {
            const response = await fetch('https://18.117.231.157/api/getUserActivities', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userID: user.userID }),
            });

            const result = await response.json();

            if (result.success && result.activities.length > 0) {
                const formatted = result.activities.map(log => {
                    const date = new Date(log.createdAt);
                    const formattedDate = `${date.toLocaleDateString('en-US', {
                        month: 'short',
                        day: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    })}`;

                    const workout = log.workout || 0;
                    const walking = (log.walking / 100) || 0;
                    const cycling = log.cycling || 0;
                    const running = log.running || 0;
                    const yoga = log.yoga || 0;
                    const meditation = log.meditation || 0;
                    const swimming = log.swimming || 0;


                    return {
                        date: formattedDate,
                        Workout: workout,
                        Swimming: swimming,
                        Cycling: cycling,
                        Running: running,
                        Yoga: yoga,
                        Meditation: meditation,
                        Walking: walking,
                        Average: parseFloat(((workout + swimming + cycling + running + yoga + meditation + walking) / 7).toFixed(2)),

                    };
                });

                setChartData(formatted);
            }
        };

        const fetchTopActivities = async () => {
            try {
                const response = await fetch('https://18.117.231.157/api/getAllTopUserActivities', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userID: user.userID })
                });

                const result = await response.json();
                if (result.success && result.topActivities.length > 0) {
                    console.log("here");
                    // Transform for radar chart
                    const radarData = result.topActivities.map(item => ({
                        activity: item.activity ? item.activity.charAt(0).toUpperCase() + item.activity.slice(1) : '',
                        value: item.topValue ? item.topValue : 0,
                    }));
                    console.log("the radar data is", radarData);
                    setTopActivities(radarData);
                }
            } catch (error) {
                console.error('Failed to fetch top activities:', error);
            }
        };


        const fetchHighestActivity = async () => {
            try {
                const response = await fetch('https://18.117.231.157/api/getUserHighestActivity', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userID: user.userID })
                });

                const result = await response.json();

                if (result.success && result.highestActivity) {
                    const { activity, total, values } = result.highestActivity;

                    const chartData = values.map(entry => ({
                        name: new Date(entry.createdAt).toLocaleDateString('en-US', {
                            month: 'short',
                            day: '2-digit'
                        }),
                        value: entry.value
                    }));

                    setData({
                        activity,
                        total,
                        chartData
                    });
                } else {
                    setData(null);
                }
            } catch (err) {
                console.error('Error fetching highest activity:', err);
                setData(null);
            }
        };

        const fetchProgress = async () => {
            try {
                const res = await fetch('https://18.117.231.157/api/getUserPlanProgress', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userID: user.userID }),
                });

                const result = await res.json();
                console.log("the result is", result);

                if (result.success && result.data) {
                    const { dailyGoal, weeklyGoal, monthlyGoal, totalGoal, averageDaily, averageWeekly, averageMonthly, total } = result.data;

                    const formatted = [
                        { goal: 'Daily', Target: dailyGoal, Achieved: averageDaily },
                        { goal: 'Weekly', Target: weeklyGoal, Achieved: averageWeekly },
                        { goal: 'Monthly', Target: monthlyGoal, Achieved: averageMonthly },
                        { goal: 'Total', Target: totalGoal, Achieved: total }
                    ];

                    setComparisonData(formatted);
                }
            } catch (err) {
                console.error('Error fetching plan progress:', err);
            }
        };

        const fetchUserPlan = async () => {
            fetch('https://18.117.231.157/api/getuseractiveplan', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userID: user.userID })
            })
                .then((res) => res.json())
                .then((data) => {
                    console.log("the data is", data);
                    if (data.success) {
                        setUsersPlan(data.plan);
                    }
                })
                .catch((err) => console.error('Error fetching user plan:', err));
            };
        



        fetchLogs();
        fetchProgress();
        fetchHighestActivity();
        fetchTopActivities();
        fetchUserPlan();
    }, [user.userID]);

    useEffect(() => {
        const fetchIndividualProgress = async () => {
            try {
                const response = await fetch('https://18.117.231.157/api/getUserIndividualActivityPlanProgress', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ userID: user.userID }),
                });

                const result = await response.json();
                if (result.success && result.data) {
                    setIndividualProgress(result.data);
                    console.log("Individual Activity Progress:", result.data);
                } else {
                    setIndividualProgress({});
                    console.warn("No individual progress data found");
                }
            } catch (error) {
                console.error('Error fetching individual activity progress:', error);
                setIndividualProgress({});
            }
        };

        if (user?.userID) {
            fetchIndividualProgress();
        }
    }, [user?.userID]);

    const capitalize = (str) => {
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    const groupLogsBy = (logs, type) => {
        const grouped = {};

        logs.forEach(log => {
            const date = new Date(log.createdAt);
            let key;

            if (type === 'week') {
                const monday = new Date(date);
                const day = monday.getDay();
                const diffToMonday = (day === 0 ? -6 : 1) - day;
                monday.setDate(monday.getDate() + diffToMonday);
                const sunday = new Date(monday);
                sunday.setDate(monday.getDate() + 6);

                const start = monday.toLocaleDateString('en-US', {
                    month: 'short',
                    day: '2-digit',
                });

                const end = sunday.toLocaleDateString('en-US', {
                    month: 'short',
                    day: '2-digit',
                });

                key = `${start} - ${end}`;
            }
            else if (type === 'month') {
                key = `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
            } else {
                key = date.toLocaleDateString('en-US');
            }

            if (!grouped[key]) {
                grouped[key] = {
                    date: key,
                    Workout: 0, Swimming: 0, Cycling: 0,
                    Running: 0, Yoga: 0, Meditation: 0, Walking: 0
                };
            }

            grouped[key].Workout += log.workout || 0;
            grouped[key].Swimming += log.swimming || 0;
            grouped[key].Cycling += log.cycling || 0;
            grouped[key].Running += log.running || 0;
            grouped[key].Yoga += log.yoga || 0;
            grouped[key].Meditation += log.meditation || 0;
            grouped[key].Walking += log.walking ? log.walking / 100 : 0;
        });

        return Object.values(grouped).sort((a, b) => new Date(a.date) - new Date(b.date));
    };

    // Trigger when grouping changes
    useEffect(() => {
        const fetchGrouped = async () => {
            const response = await fetch('https://18.117.231.157/api/getUserActivities', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userID: user.userID }),
            });
            const result = await response.json();
            console.log("the individual result is", result);

            if (result.success && result.activities.length > 0) {
                const grouped = groupLogsBy(result.activities, grouping);
                setGroupedChartData(grouped);
            }
        };

        fetchGrouped();
    }, [grouping]);




    return (
        <div>
            <ProfileNavBar />
            <br /><br /><br /><br /><br />
            <h1 className='contactuspageheaders'>Progress Dashboard</h1>

            <div className='checkboxes'>
                <label><input type="checkbox" checked={showWorkout} onChange={() => setShowWorkout(!showWorkout)} /> Workout</label>
                <label><input type="checkbox" checked={showSwimming} onChange={() => setShowSwimming(!showSwimming)} /> Swimming</label>
                <label><input type="checkbox" checked={showCycling} onChange={() => setShowCycling(!showCycling)} /> Cycling</label>
                <label><input type="checkbox" checked={showRunning} onChange={() => setShowRunning(!showRunning)} /> Running</label>
                <label><input type="checkbox" checked={showYoga} onChange={() => setShowYoga(!showYoga)} /> Yoga</label>
                <label><input type="checkbox" checked={showMeditation} onChange={() => setShowMeditation(!showMeditation)} /> Meditation</label>
                <label><input type="checkbox" checked={showWalking} onChange={() => setShowWalking(!showWalking)} /> Walking</label>
            </div>
            <br></br>

            {chartData.length > 0 ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <ComposedChart width={630} height={400} data={chartData}>
                        <XAxis dataKey="date" tick={{ fill: '#f5f5f5' }} />
                        <YAxis tick={{ fill: '#f5f5f5' }} />
                        <Tooltip />
                        <Legend />
                        <CartesianGrid stroke="#f5f5f5" />
                        {showWorkout && <Bar dataKey="Workout" barSize={10} fill="#8884d8" />}
                        {showSwimming && <Bar dataKey="Swimming" barSize={10} fill="#82ca9d" />}
                        {showCycling && <Bar dataKey="Cycling" barSize={10} fill="#ffc658" />}
                        {showRunning && <Bar dataKey="Running" barSize={10} fill="#ff7300" />}
                        {showYoga && <Bar dataKey="Yoga" barSize={10} fill="#ff0000" />}
                        {showMeditation && <Bar dataKey="Meditation" barSize={10} fill="#00ff00" />}
                        {showWalking && <Bar dataKey="Walking" barSize={10} fill="#0000ff" />}
                        <Line type="monotone" dataKey="Average" stroke="#2626e4" />
                    </ComposedChart>
                </div>
            ) : (
                <p style={{ textAlign: 'center', marginTop: '2rem' }}>No activity data available to display.</p>
            )}

            <br></br>
            <div className='rowtype' style={{ alignItems: 'stretch' }}>
                <div style={{ padding: '2rem', textAlign: 'center', margin: 0 }} className='logTile'>
                    <h2>Top Activities</h2>
                    {topActivities.length > 0 ? (
                        <div style={{ width: '100%', height: 300, display: 'flex', justifyContent: 'center' }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <RadarChart cx="50%" cy="50%" outerRadius="80%" data={topActivities}>
                                    <PolarGrid />
                                    <PolarAngleAxis dataKey="activity" />
                                    <PolarRadiusAxis />
                                    <Tooltip />
                                    <Radar name="Top Activity Values" dataKey="value" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
                                </RadarChart>
                            </ResponsiveContainer>
                        </div>
                    ) : (
                        <p style={{ textAlign: 'center', marginTop: '2rem' }}>No activity data found.</p>
                    )}
                </div>
                <div style={{ padding: '2rem', textAlign: 'center' }} className='logTile'>
                    {data && (
                        <>
                            <h2><FaTrophy style={{ color: 'gold' }} /> Highest Logged Activity: {capitalize(data.activity)}</h2>
                            <p><strong>Total:</strong> {data.total}</p>

                            <ResponsiveContainer width="100%" height={300}>
                                <BarChart data={data.chartData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="value" fill="#82ca9d" name="Activity Value" />
                                </BarChart>
                            </ResponsiveContainer>
                        </>
                    )}



                </div>



            </div>


            <div style={{ width: '80%', height: '140%', marginTop: '1rem' }} className='logTile'>
                <h2 style={{ textAlign: 'center' }}>Grouped Activity Summary</h2>
                <ResponsiveContainer width="100%" height={300}>
                    <ComposedChart data={groupedChartData}>
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <CartesianGrid stroke="#ccc" />
                        <Bar dataKey="Workout" stackId="a" fill="#8884d8" />
                        <Bar dataKey="Swimming" stackId="a" fill="#82ca9d" />
                        <Bar dataKey="Cycling" stackId="a" fill="#ffc658" />
                        <Bar dataKey="Running" stackId="a" fill="#ff7300" />
                        <Bar dataKey="Yoga" stackId="a" fill="#ff0000" />
                        <Bar dataKey="Meditation" stackId="a" fill="#00ff00" />
                        <Bar dataKey="Walking" stackId="a" fill="#0000ff" />
                    </ComposedChart>
                </ResponsiveContainer>
                <div style={{ textAlign: 'center', marginTop: '2rem' }} className='checkboxes'>
                    <label htmlFor="grouping-select">Group by: </label>
                    <select id="grouping-select" value={grouping} onChange={(e) => setGrouping(e.target.value)}>
                        <option value="day">Day</option>
                        <option value="week">Week</option>
                        <option value="month">Month</option>
                    </select>
                </div>
            </div>
            {usersPlan && (
  <>
    <div>
      <h1 className='contactuspageheaders'>Your Plan Progress</h1>

      <div style={{ width: '90%', height: 400, margin: 'auto' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={comparisonData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="goal" />
            <YAxis />
            <Tooltip formatter={(value, name) => [`${value}`, name === "Target" ? "Target" : "Achieved"]} />
            <Legend />
            <Bar dataKey="Target" fill="#8884d8" />
            <Bar dataKey="Achieved" fill="#82ca9d" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>

    <div className="checkboxes" style={{ justifyContent: 'center', width: '30%' }}>
      <label><input type="radio" value="daily" checked={frequency === 'daily'} onChange={(e) => setFrequency(e.target.value)} /> Daily</label>
      <label><input type="radio" value="weekly" checked={frequency === 'weekly'} onChange={(e) => setFrequency(e.target.value)} /> Weekly</label>
      <label><input type="radio" value="monthly" checked={frequency === 'monthly'} onChange={(e) => setFrequency(e.target.value)} /> Monthly</label>
    </div>

    <br />
    <h2 className='contactuspageheaders'>{capitalize(frequency)} Goal</h2>
    <div className='grid-container2'>
      {Object.entries(individualProgress).map(([activity, data]) => {
        const actual = data[frequency];
        const goal = data[`${frequency}Goal`];

        return (
          <div key={activity} className="activity-donut-container">
            <h2 style={{ textAlign: 'center' }}>{capitalize(activity)}</h2>
            <ResponsiveContainer width={200} height={130}>
              <PieChart>
                <Pie
                  data={[
                    { name: 'Achieved', value: actual },
                    { name: 'Remaining', value: Math.max(goal - actual, 0) }
                  ]}
                  cx="50%"
                  cy="50%"
                  innerRadius={30}
                  outerRadius={60}
                  paddingAngle={3}
                  dataKey="value"
                >
                  <Cell fill={COLORS[0]} />
                  <Cell fill="#36333e" />
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
            <p style={{ textAlign: 'center' }}>{actual} / {goal}</p>
          </div>
        );
      })}
    </div>
  </>
)}


<ChatComponent/>


            <br /><br /><br />
            <UserFooter />
            <Footer />
        </div>
    );
};

export default ProgressDashboard;
